import { useSelector, useDispatch } from 'react-redux';
import { setDayMenuDate } from '../../Redux/store';
import CloseButton from '../../components/CloseButton';
import DayMenuContent from './DayMenuContent';
import { useEffect } from 'react';
import usePredictedCalendar from '../../data/cycle-predictions/usePredictedCalendar';
import ModalWrapper from '../../components/ModalWrapper';

function CalendarDayMenu() {
  const dispatch = useDispatch();
  const date = useSelector((s) => s.ui.calendarDayDate);
  // Use the clicked date as endDate to ensure predictions are available for that date
  const { calendarData } = usePredictedCalendar(date);
  const role = useSelector((s) => s.user.profile?.role) ?? 'ip';

  const dayData = date ? calendarData?.[date] : null;

  if (!date) return null;

  const close = () => dispatch(setDayMenuDate(null));

  const pretty = new Date(date + 'T00:00').toLocaleDateString(undefined, {
    weekday: 'long', month: 'long', day: 'numeric',
  });

  return (
    <ModalWrapper onClose={close} height="h-[95%]">
      {/* Fixed top header */}
      <div className="p-5 flex items-center justify-between flex-shrink-0">
        <h3 className="text-lg font-semibold">{pretty}</h3>
        <CloseButton onClose={close} />
      </div>

      {/* Middle content - ovulation tests will fill remaining space */}
      <DayMenuContent dayData={dayData} role={role} date={date} userId={null} />

      {/* Fixed bottom button */}
      <div className="p-3 flex-shrink-0">
        <button onClick={close} className="w-full rounded-full bg-primary py-2.5 text-sm font-semibold text-primary-foreground">
          Done
        </button>
      </div>
    </ModalWrapper>
  );
}

export default CalendarDayMenu;
